<div class="modal-header">
    <h4 class="modal-title">
        <span class="title-main">
            Non-Runner:
        </span>

        
        <span class="title-details">
            {{ nonRunner.make }}
            {{ nonRunner.model }}
            |
            {{ nonRunner.vrm }}
        </span>


        <span class="title-progress">
            [{{ currentIndex + 1 }}/{{ nonRunners.length }}]
        </span>
    </h4>

    <img class="modal-close" (click)="dismissModal()" alt="Dismiss modal">
</div>

<div class="modal-body">

    <div class="alert-text">
        When you submit this form, the owner will see your name and email address.
    </div>
    <div class="row">
        <div class="col-md-6">
            <div class="mb-4" *ngFor="let question of visibleQuestions | slice:0:2; let i = index">

                <ng-container *ngIf="question.controls.name.value !== 'additionalNotes'; else leftText">
                    <app-list-input [group]="question"
                        [customLabel]="getQuestionNumber(question) + '. ' + question.controls.question.value"
                        [requiredIndicator]="true" [options]="yesNoOptions" (change)="onAnswerChange($event)">
                    </app-list-input>

                </ng-container>

                <ng-template #leftText>
                    <app-text-input [group]="question"
                        [customLabel]="getQuestionNumber(question) + '. ' + question.controls.question.value"
                        (change)="onAnswerChange($event)">
                    </app-text-input>
                </ng-template>

            </div>

        </div>

        <!-- Right column -->
        <div class="col-md-6">

            <div class="mb-4" *ngFor="let question of visibleQuestions | slice:2; let i = index">

                <ng-container *ngIf="question.controls.name.value !== 'additionalNotes'; else rightText">
                    <app-list-input [group]="question"
                        [customLabel]="getQuestionNumber(question) + '. ' + question.controls.question.value"
                        [requiredIndicator]="true" [options]="yesNoOptions" (change)="onAnswerChange($event)">
                    </app-list-input>

                </ng-container>

                <ng-template #rightText>
                    <app-text-input [group]="question" [isPreFilledAnswer]="false" [customLabel]="getQuestionNumber(question) + '. ' + question.controls.question.value"
                        (change)="onAnswerChange($event)">
                    </app-text-input>
                </ng-template>

            </div>
        </div>

    </div>

    <div class="non-runner-btn center">
        <button class="modal-button button_green" (click)="next()"
            [ngClass]="{'active':canContinue, 'invalid':!canContinue}" [disabled]="!canContinue">
            <span *ngIf="!isLast" class="next-btn-icon" [ngClass]="{ 'invalid': !canContinue }"></span>
            <span class="next-btn-span">{{ isLast ? 'Submit' : 'Next' }}</span>
        </button>
    </div>